exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".nav-link{cursor:pointer}", "", {"version":3,"sources":["/home/davidwolff/projects/scms/secure-customer-messaging-ui/src/components/Sidebar.vue"],"names":[],"mappings":"AACA,UACE,cAAe,CAChB","file":"Sidebar.vue","sourcesContent":["\n.nav-link {\n  cursor:pointer;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75373e29","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Sidebar.vue
// module id = fe/f
// module chunks = 1